import { gql } from '@apollo/client'

export const SET_APPROVE_STATUS = gql`
  mutation SetApproveStatus($userID: ID!, $isApproved: Boolean!) {
    setApproveStatus(userID: $userID, isApproved: $isApproved)
  }
`
